var map = {
	"./img_1.png": 13780,
	"./img_2.png": 4780,
	"./img_3.png": 70717,
	"./img_4.png": 96293,
	"./img_5.png": 36180,
	"./img_6.png": 85163,
	"./img_7.png": 25070,
	"./img_8.png": 33826,
	"./img_9.png": 48118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59781;